import { Pipe, PipeTransform } from '@angular/core';

import { TagOption } from '@sui/tags';

/**
 * Maps tag-input items to sui-tags' `{ label, value }` options. Two shapes:
 * - **objects** (dynamic-form `tag-input`): keyed by `displayBy` (default
 *   `'text'`) / `identifyBy` (default `'id'`).
 * - **primitives** (e.g. search-builder free-text term suggestions, plain
 *   `string[]`): mapped to themselves (`{ label: String(item), value: item }`).
 * Pure: re-maps only when the input array (or a key) changes, so the tag pool
 * isn't rebuilt every CD cycle.
 */
@Pipe({
  name: 'tagsOptions',
  standalone: false,
})
export class TagsOptionsPipe implements PipeTransform {
  transform(
    items: Array<Record<string, unknown> | string | number> | null | undefined,
    displayBy = 'text',
    identifyBy = 'id',
  ): TagOption[] {
    if (!items) return [];
    return items.map((it) => {
      if (it === null || typeof it !== 'object') {
        return { label: String(it), value: it };
      }
      return { label: String(it[displayBy] ?? ''), value: it[identifyBy] };
    });
  }
}
